// App-side delegate for `@heidi/templates/data` (S1/S3, ARCFE-1018).
//
// Three app effects stayed, each wired to the port that fires where it used to:
// the two analytics dispatches, the regulatory-guideline modal atom (UI state),
// and both toasts. The package keeps the compliance CLASSIFICATION, because
// reading a wire contract is data.
import { regulatoryGuidelineWarningModalOpenAtom } from '@/components/ui/template-builder-edit-dialog-button/regulatory-guideline-warning-modal.atoms';
import { trackCommunityTemplateImported } from '@/lib/analytics/scribe/community';
import { trackNhsTemplateComplianceWarning } from '@/lib/analytics/scribe/compliance';
import { toast } from '@heidi/design-system/toast';
import { useMutateImportTemplateFromGallery as useMutateImportTemplateFromGalleryCore } from '@heidi/templates/data';
import { useSetAtom } from 'jotai';

export function useMutateImportTemplateFromGallery() {
  const setIsRegulatoryGuidelineWarningModalOpen = useSetAtom(
    regulatoryGuidelineWarningModalOpenAtom
  );

  return useMutateImportTemplateFromGalleryCore({
    onImported: (sourceTemplateId) => {
      if (sourceTemplateId) {
        trackCommunityTemplateImported({
          templateId: sourceTemplateId,
        });
      }
      toast({
        tone: 'success',
        title: 'Successfully imported template from community',
      });
    },
    onComplianceWarning: ({ complianceOutputLength, templateId }) => {
      trackNhsTemplateComplianceWarning({
        compliance_output_length: complianceOutputLength,
        template_id: templateId,
        template_source: 'gallery_import',
      });
      setIsRegulatoryGuidelineWarningModalOpen(true);
    },
    onImportFailed: () => {
      toast({
        tone: 'destructive',
        title: 'Failed to import template from gallery',
        // description: error.errors[0]?.message,
      });
    },
  });
}
